module.exports = __webpack_public_path__ + "img/DW365-344.2869ce11.jpg";